// extracted by mini-css-extract-plugin
export default {"box":"styles-module--box--2e9l_","faded":"styles-module--faded--23DKL"};